<template>
  <SalesPlayDrawerCard>
    <div class="drawer-section">
      <div class="drawer-sectionLabel">IDEAL CUSTOMER PROFILE</div>
      <p class="drawer-hint">Firmographic targeting. The auto-approval gate scores candidates against these criteria. Leave a field blank to skip it.</p>
    </div>

    <div class="drawer-field">
      <label class="drawer-fieldLabel">Industry</label>
      <input class="drawer-fieldInput" v-model="local.industry" placeholder="e.g. B2B SaaS, Healthcare IT" maxlength="500" @blur="applyIcp" />
    </div>

    <div class="drawer-field">
      <label class="drawer-fieldLabel">Geography</label>
      <input class="drawer-fieldInput" v-model="local.geography" placeholder="e.g. North America, EMEA" maxlength="500" @blur="applyIcp" />
    </div>

    <div class="drawer-field">
      <label class="drawer-fieldLabel">Funding stage</label>
      <input class="drawer-fieldInput" v-model="local.funding_stage" placeholder="e.g. Series B–D, Public" maxlength="500" @blur="applyIcp" />
    </div>

    <div class="drawer-field">
      <label class="drawer-fieldLabel">Revenue</label>
      <input class="drawer-fieldInput" v-model="local.revenue" placeholder="e.g. $10M–$100M ARR" maxlength="500" @blur="applyIcp" />
    </div>

    <div class="drawer-field">
      <label class="drawer-fieldLabel">Company size</label>
      <input class="drawer-fieldInput" v-model="local.company_size" placeholder="e.g. 50–500 employees" maxlength="500" @blur="applyIcp" />
    </div>

    <div class="drawer-field">
      <label class="drawer-toggleField">
        <ToggleSwitch :model-value="local.fail_on_missing_data" @update:model-value="onToggleFailOnMissingData" />
        <span class="drawer-toggleLabel">Exclude companies we can't enrich</span>
      </label>
      <p class="drawer-hint">When enabled, companies without firmographic data from LeadIQ will be excluded. When disabled, they pass through.</p>
    </div>
  </SalesPlayDrawerCard>
</template>

<script setup lang="ts">
import { reactive, watch } from 'vue'
import ToggleSwitch from '../../../components/ToggleSwitch.vue'
import SalesPlayDrawerCard from './SalesPlayDrawerCard.vue'
import { useSalesPlayDraft } from '../../composables/useSalesPlayDraft'

const props = defineProps<{
  playId: string
  pipelineId: string | null
  nodeIndex: number
}>()

const { nodes, updateNodeConfig } = useSalesPlayDraft()

const currentConfig = () => nodes.value[props.nodeIndex]?.config || {}

const local = reactive({
  industry: '',
  geography: '',
  funding_stage: '',
  revenue: '',
  company_size: '',
  fail_on_missing_data: true,
})

function resetLocal() {
  const icp = currentConfig().icp || {}
  local.industry = icp.industry || ''
  local.geography = icp.geography || ''
  local.funding_stage = icp.funding_stage || ''
  local.revenue = icp.revenue || ''
  local.company_size = icp.company_size || ''
  local.fail_on_missing_data = currentConfig().fail_on_missing_data !== false
}

resetLocal()

watch(() => nodes.value[props.nodeIndex]?.config, () => {
  resetLocal()
}, { deep: true })

function applyIcp() {
  const icp: Record<string, string> = {}
  if (local.industry.trim()) icp.industry = local.industry.trim()
  if (local.geography.trim()) icp.geography = local.geography.trim()
  if (local.funding_stage.trim()) icp.funding_stage = local.funding_stage.trim()
  if (local.revenue.trim()) icp.revenue = local.revenue.trim()
  if (local.company_size.trim()) icp.company_size = local.company_size.trim()
  updateNodeConfig(props.nodeIndex, { icp })
}

function onToggleFailOnMissingData(next: boolean) {
  local.fail_on_missing_data = next
  updateNodeConfig(props.nodeIndex, { fail_on_missing_data: next })
}
</script>
